import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import cn from 'classnames';

const CurrentTime = ({
  className,
  seconds
}) => {
  const timeRef = useRef(null);
  const initializedTime = seconds ? moment().format('LTS') : moment().format('LT');
  const [time, setTime] = useState(initializedTime);
  useEffect(() => {
    if (timeRef.current) {
      clearInterval(timeRef.current);
    }
    timeRef.current = setInterval(() => {
      const getTime = seconds ? moment().format('LTS') : moment().format('LT');
      setTime(getTime);
    }, 1000);
    return () => {
      clearInterval(timeRef.current);
    };
  }, []);
  return (
    <div className={cn(className)}>
      {time}
    </div>
  );
};

export default CurrentTime;
